export default  {
  bindings: {
    page: '=',
    title: '@',
    type: '<'
  },
  controller: 'pageContentSaveController',
  template: require('../views/pageContent.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/components/pageContent.save.component.js